import React, { Component } from "react";
import Button from '../Button/Button';
import logo from '../../assets/images/arizona-logo.svg'
import Style from './Header.css';

class Header extends Component{
	render(){
		return(
			<div style={Style.header} className="header">
				<header>
					<div className="container">
						<a target="_blank" className="arizona-logo" href="https://www.arizona.edu" rel="noopener" id="Uarizona-Homepage"><img src={logo} alt="The University of Arizona Logo" /></a>
						<div className="button_wrap">
							<Button buttonLink="https://slate.admissions.arizona.edu/apply/" buttonId="Apply-Now-Header" buttonTitle="APPLY NOW" />
						</div>
					</div>
				</header>
			</div>
		)
	}
}


export default Header;
